export default "__VITE_ASSET__C6Kdlnw3__"